import { useEffect } from 'react'

export function usePreloadTutorialVideo(): void {
  useEffect(() => {
    const video = document.createElement('video')
    video.src = 'https://cdn.spark.fi/base-mini-app/tutorial/1.mp4'
    video.preload = 'auto'
    video.load()

    return () => {
      video.src = ''
      video.load()
    }
  }, [])
}
